import { render, staticRenderFns } from "./youshi.vue?vue&type=template&id=2a60e075&scoped=true&"
import script from "./youshi.vue?vue&type=script&lang=js&"
export * from "./youshi.vue?vue&type=script&lang=js&"
import style0 from "./youshi.vue?vue&type=style&index=0&id=2a60e075&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a60e075",
  null
  
)

export default component.exports